import useSWR, { type SWRConfiguration } from 'swr';

import {
  getPaymentsSubscriptionsCurrent,
  type GetPaymentsSubscriptionsCurrentResponse,
} from '@services/PaymentsService';

export type UseGetPaymentsSubscriptionsCurrentParams = {
  swrOptions?: SWRConfiguration<
    GetPaymentsSubscriptionsCurrentResponse,
    unknown
  >;
};

export const getPaymentsSubscriptionsCurrentQueryKey =
  'get-payments-subscriptions-current';

export const useGetPaymentsSubscriptionsCurrent = ({
  swrOptions,
}: UseGetPaymentsSubscriptionsCurrentParams = {}) => {
  const { data, ...swrResponse } =
    useSWR<GetPaymentsSubscriptionsCurrentResponse>(
      getPaymentsSubscriptionsCurrentQueryKey,
      () => getPaymentsSubscriptionsCurrent(),
      swrOptions,
    );

  return {
    data,
    ...swrResponse,
  };
};
